/* eslint-disable max-len */
import { Entity, SystemInterface } from '@goodboydigital/odie';
import gsap from 'gsap';

import { Game } from '../Game';

type Tween = gsap.core.Tween;

/**
 * Manage tweens that should be tied to game's delta time
 */
export class TweenSystem implements SystemInterface
{
    public game: Game;

    public tweens: Tween[];

    constructor(entity: Entity)
    {
        this.game = entity.scene as Game;
        this.tweens = [];
    }

    public add(tween: Tween): Tween
    {
        tween.pause();
        this.tweens.push(tween);

        return tween;
    }

    public to(targets: gsap.TweenTarget, vars: gsap.TweenVars): Tween
    {
        const tween = gsap.to(targets, vars);

        return this.add(tween);
    }

    public kill(targets: gsap.TweenTarget): void
    {
        gsap.killTweensOf(targets);
    }

    public postupdate(): void
    {
        this.updateTweens(this.game.time.deltaTime / 1000);
    }

    public updateTweens(delta?: number): void
    {
        if (!delta) delta = 1 / 60;
        let i = this.tweens.length;

        while (i--)
        {
            const tween = this.tweens[i];

            if (!tween.parent)
            {
                this.tweens.splice(i, 1);
                continue;
            }

            if ((tween as any)._delay)
            {
                (tween as any)._delay -= delta;
                if ((tween as any)._delay <= 0) (tween as any)._delay = 0;
                continue;
            }

            tween.time(tween.time() + delta);
            if (tween.time() === tween.totalDuration())
            {
                this.tweens.splice(i, 1);
                tween.kill();
            }
        }
    }
}
